export default __webpack_public_path__ + "static/assets/ace256c43fe80fd732b7aa7b5cfb0554.png";